import * as Yup from "yup";

export const initialValues = {
  id: "",
  name: "",
  description: "",
  order: "",
};

export const validationSchema = Yup.object({
  id: Yup.string()
    .trim()
    .required("El código del esquema es obligatorio.")
    .max(50, "El código no puede superar 50 caracteres."),

  name: Yup.string()
    .trim()
    .required("El nombre del esquema es obligatorio.")
    .min(3, "El nombre debe contener al menos 3 caracteres.")
    .max(100, "El nombre no puede superar 100 caracteres."),

  description: Yup.string()
    .trim()
    .max(500, "La descripción no puede superar 500 caracteres."),

  order: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .typeError("El orden debe ser un número válido.")
    .integer("El orden debe ser un número entero.")
    .min(1, "El orden debe ser mayor o igual a 1.")
    .required("El orden de visualización es obligatorio."),
});